export class RevalidateRestoreTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "report",
            "baseName": "report",
            "type": "RevalidationReport",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RevalidateRestoreTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
